import React, { useEffect, useRef, useState } from 'react';
import Wrapper from '../../../assets/wrappers/FinalResult';
import { useLocation, useNavigate } from 'react-router-dom';
import { languages, regionalLanguages, setIsDirty } from '../../../features/upload/uploadSlice';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { marked } from 'marked';
import TranslateSummary from './TranslateSummary';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import PanchayatiRajLogo from '../../../assets/images/PanchayatiRajLogo.png';
import html2pdf from "html2pdf.js";
import { RootState } from '../../../store';
import protectedAPI from '../../../services/axiosInstance';
import axios from 'axios';

const FaListAlt = require('react-icons/fa').FaListAlt;
const FaPencilAlt = require('react-icons/fa').FaPencilAlt;
const FaRegCopy = require('react-icons/fa').FaRegCopy;
const FaCaretDown = require('react-icons/fa').FaCaretDown;
const FaGlobe = require('react-icons/fa').FaGlobe;
const FaFileAlt = require('react-icons/fa').FaFileAlt;
const FaDownload = require('react-icons/fa').FaDownload;
const FaExclamationTriangle = require('react-icons/fa').FaExclamationTriangle;
const FaCheckCircle = require('react-icons/fa').FaCheckCircle;


const FinalResult: React.FC = () => {
    const { portal, meetingDetailsNirnany } = useSelector((state: RootState) => state.auth);
    const location = useLocation();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [htmlSummaryReg, setHtmlSummaryReg] = useState<string>("");
    const [showConfirm, setShowConfirm] = useState(false);
    const task_id = useSelector((state: any) => state.upload.apiInfo?.task_id);
    const [selectedLang, setSelectedLang] = useState<any>('')
    const [selectedLangId, setSelectedLangId] = useState<number | null>(null);
    const file = useSelector((state: any) => state.upload.file);
    const meetingAttendees = useSelector((state: any) => state.upload.meetingAttendees);
    const result = useSelector((state: any) => state.upload.result);
    const [summaryHtml, setSummaryHtml] = useState('');
    const summaryRef = useRef<HTMLDivElement>(null);
    const [regionalContent, setRegionalContent] = useState<any>(false)
    const [regionalLangCode, SetRegionalLangCode] = useState<any>('')
    const [isLoadingTranslation, setIsLoadingTranslation] = useState(false);
    const [isEditing, setIsEditing] = useState(true);
    const [isEditDisabled, setIsEditDisabled] = useState(false);
    const [showResultModal, setShowResultModal] = useState(false);
    const [isSuccess, setIsSuccess] = useState<boolean | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const { isDirty } = useSelector((state: RootState) => state.upload);
    const dispatch = useDispatch();



    const [storageData, setStorageData] = useState<any>(() => {
        const saved = localStorage.getItem('loginDetails');
        try {
            return saved ? JSON.parse(saved) : {};
        } catch (e) {
            console.error('Failed to parse loginDetails from localStorage:', e);
            return {};
        }
    });
    const [toggle, setToggle] = useState<any>({
        originTranscipt: false,
        translatedTranscriptEn: false,
        summaryEn: false,
        extraTab: false,
    })

    const navigate = useNavigate();

    const confirmLeavePage = () => {
        const currentPath = location.pathname;
        const shouldShowConfirm =
            (currentPath === "/processing" ||
                currentPath.startsWith("/draft-meeting/")) &&
            !isDirty;
        if (!shouldShowConfirm) return true;
        return window.confirm(
            "You have unsubmitted changes in your SabhaSaar MoM data. Are you sure you want to leave?"
        );
    };
    const handleNewFile = () => {
        if (!confirmLeavePage()) return;

        navigate("/upload");
    };
    useEffect(() => {
        const selectedLanguage = languages.find((item: any) => item.code === file.language);
        setSelectedLang(selectedLanguage?.label || '');
        setSelectedLangId(selectedLanguage?.id || null);
    }, [file])

    const handleCopy = (text: string) => {
        if (!text?.trim()) {
            toast.error('No Audio Content Available to copy');
            return;
        }

        navigator?.clipboard?.writeText(text)
            .then(() => toast.success('Copied to clipboard!'))
            .catch(() => toast.error('Failed to copy!'));
    };


    const handleCopyRendered = (htmlString: string) => {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = htmlString;
        const plainText = tempElement.textContent || tempElement.innerText || '';
        if (!plainText.trim()) {
            toast.error('No content available to copy');
            return;
        }
        navigator?.clipboard?.writeText(plainText)
            .then(() => toast.success('Copied to clipboard!'))
            .catch(() => toast.error('Failed to copy!'));
    };

    const handleSectionToggle = (section: keyof typeof toggle) => {
        setToggle({
            originTranscipt: false,
            translatedTranscriptEn: false,
            summaryEn: false,
            extraTab: false,
            [section]: !toggle[section],
        });
    };

    useEffect(() => {
        const convertSummary = async () => {
            if (result?.summary_en) {
                const html = await marked.parse(result.summary_en);
                setSummaryHtml(html);
                handleLanguageTranslate(file?.language)
            }
        };
        convertSummary();
    }, [result?.summary_en]);

    const handleExportPDF = () => {
        if (!summaryHtml) {
            toast.error("No content to export.");
            return;
        }

        const dateOnly = file.date.split("T")[0];

        const {
            state_name_english,
            zpname,
            zpcode,
            bpname,
            bpcode,
            gpname,
            gpcode
        } = storageData || {};

        const element = document.createElement("div");
        element.style.width = "100%";
        element.style.maxWidth = "794px";

        element.innerHTML = `

<link href="https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;500&display=swap" rel="stylesheet">

<style>

.pdf-root{
  font-family:'Noto Sans', Arial, sans-serif;
  font-size:19px;
  line-height:1.7;
}

/* paragraphs */

.pdf-root p,
.pdf-root li{
  line-height:1.7;
  margin-bottom:6px;
  word-break:normal;
  overflow-wrap:anywhere;
  white-space:normal;
  page-break-inside:avoid;
  break-inside:avoid;
}

/* lists */

.pdf-root ul,
.pdf-root ol{
  padding-left:18px;
  page-break-inside:avoid;
}

/* headings */

.pdf-root h1,
.pdf-root h2,
.pdf-root h3,
.pdf-root h4{
  page-break-after:avoid;
}

/* images */

.pdf-root img{
  max-width:100%;
  page-break-inside:avoid;
}

/* blocks */

.pdf-block{
  page-break-inside:avoid;
  break-inside:avoid;
}

/* content */

.minutes-content{
  line-height:1.7;
}

/* disclaimer */

.disclaimer{
  margin-top:10px;
}

</style>

<div class="pdf-root">

<!-- Header -->

<div class="pdf-block" style="display:flex; align-items:center; gap:7px; margin-bottom:10px;">
  <img src="${PanchayatiRajLogo}" alt="Logo" style="height:50px;" />

  ${state_name_english ? `<div>State: ${state_name_english}</div>` : ""}

  ${zpname ? `<div>ZP: ${zpname}${zpcode ? ` (${zpcode})` : ""}</div>` : ""}

  ${bpname ? `<div>BP: ${bpname}${bpcode ? ` (${bpcode})` : ""}</div>` : ""}

  ${gpname ? `<div>GP: ${gpname}${gpcode ? ` (${gpcode})` : ""}</div>` : ""}

</div>

<hr/>

<!-- Meeting Info -->

<div class="pdf-block">

  <div><b>Meeting Type:</b> ${file.meetingTypeName || "-"}</div>

  <div><b>Meeting Title:</b> ${file.meetingTitle || "-"}</div>

  <div><b>Meeting Date:</b> ${dateOnly}</div>

</div>

<!-- Main Content -->

<div class="minutes-content">

${summaryHtml}

</div>

<!-- Disclaimer -->

<div class="pdf-block disclaimer">

<p>
<b class="text-danger">DISCLAIMER:</b>
The AI-assisted summaries are based on uploaded audio/video and may contain errors due to input quality or language variation.
Please verify the content before official use.
The Ministry of Panchayati Raj is not liable for any discrepancies.
</p>

</div>

</div>
`;

        const opt: any = {
            margin: [15, 10, 15, 10],
            filename: "Minutes_of_Meeting.pdf",

            image: { type: "jpeg", quality: 0.98 },

            html2canvas: {
                scale: 2,
                useCORS: true,
                letterRendering: true
            },

            jsPDF: {
                unit: "mm",
                format: "a4",
                orientation: "portrait"
            },

            pagebreak: {
                mode: ["css", "legacy"]
            }
        };

        html2pdf()
            .set(opt)
            .from(element)
            .save()
            .then(() => toast.success("Exported as PDF"))
            .catch((err: any) => {
                console.error(err);
                toast.error("Failed to export PDF.");
            });
    };


    const handleLanguageTranslate = async (langCode: string) => {
        if (langCode === "en") {
            return true;
        }

        try {
            setIsLoadingTranslation(true);
            setRegionalContent(false);
            SetRegionalLangCode(langCode);

            const response = await protectedAPI.post(
                `${baseUrl}api/translate-summary`,
                {
                    task_id: task_id,
                    en_summary: summaryHtml || result?.summary_en,
                    target_language: langCode,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = response.data;

            if (data?.msg_code === 200) {
                setRegionalContent(data);
            } else if (data?.msg_code === 500) {
                toast.error("Internal Server Error");
                setRegionalContent(false);
            }
        } catch (error) {
            console.error("Translation Error:", error);
            setRegionalContent(false);
        } finally {
            setIsLoadingTranslation(false);
        }
    };

    const handleSubmit = async () => {
        try {
            setIsEditing(false);
            setIsEditDisabled(true);
            const payload = {
                task_id: task_id,
                target_language: "en",
                edited_minutes: summaryHtml,
            };
            const res = await protectedAPI.post(
                `${baseUrl}api/submit-edited-summary`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = res.data;
            if (data?.msg_code === 200) {
                toast.success(data.msg || "Changes submitted successfully");
                handleLanguageTranslate(file?.language)
            } else {
                toast.error(data?.msg || "Something went wrong while submitting.");
                setIsEditing(true);
                setIsEditDisabled(false);
            }
        } catch (error: any) {
            console.error("Error submitting edited summary:", error);
            toast.error(
                error?.response?.data?.msg ||
                "Failed to submit changes. Please try again."
            );
            setIsEditing(true);
            setIsEditDisabled(false);
        }
    };


    const generatePdfBlob = async (htmlContent: string, filename = "mom.pdf") => {
        const element = document.createElement("div");
        element.style.width = "100%";
        element.style.maxWidth = "794px";
        element.innerHTML = htmlContent;

        const opt: any = {
            margin: [15, 10, 15, 10],
            filename,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
            pagebreak: { mode: ["avoid-all", "css", "legacy"] },
        };

        const worker = html2pdf().set(opt).from(element);
        const blob = await worker.outputPdf("blob");
        return blob;
    };



    const handleConfirmSubmit = async () => {
        setShowConfirm(false);
        setLoading(true);
        const {
            state_code,
            zpcode,
            bpcode,
            gpcode,
            entity_level,
            ip,
            user_id,
            user_name,
            state_name_english,
            zpname,
            bpname,
            gpname,
        } = storageData || {};

        const local_body_code = gpcode ?? bpcode ?? zpcode ?? state_code;
        try {
            /* ---------------- PDF HTML format ---------------- */

            const commonHeaderHtml = `
            <div style="display:flex; align-items:center; gap:7px; margin-bottom:10px;">
            <img src="${PanchayatiRajLogo}" style="height:50px;" />
            ${state_name_english ? `<div>State: ${state_name_english}</div>` : ""}
            ${zpname ? `<div>ZP: ${zpname}${zpcode ? ` (${zpcode})` : ""}</div>` : ""}
            ${bpname ? `<div>BP: ${bpname}${bpcode ? ` (${bpcode})` : ""}</div>` : ""}
            ${gpname ? `<div>GP: ${gpname}${gpcode ? ` (${gpcode})` : ""}</div>` : ""}
            </div>
            <hr/>
            <div style="margin-bottom:10px;">
            <div><b>Meeting Type:</b> ${file.meetingTypeName || "-"}</div>
            <div><b>Meeting Title:</b> ${file.meetingTitle || "-"}</div>
            </div>
            `;


            const disclaimer = `
            <div style="margin-top:10px">
            <div>
                <p>
                <b>DISCLAIMER:</b>
                The AI-assisted summaries are based on uploaded audio/video and may contain errors due to input quality or language variation.
                Please verify the content before official use.
                The Ministry of Panchayati Raj is not liable for any discrepancies.
                </p>
            </div>
            </div>
            `;


            const englishPdfHtml = `
            ${commonHeaderHtml}
            <div>${summaryHtml}</div>
            ${disclaimer}
        `;

            const regionalPdfHtml = `
            ${commonHeaderHtml}
            <div>${htmlSummaryReg}</div>
            ${disclaimer}
        `;

            /* ---------------- Generate PDF blobs ---------------- */
            const enPdfBlob = await generatePdfBlob(englishPdfHtml, "english_mom.pdf");
            const regPdfBlob = await generatePdfBlob(regionalPdfHtml, "regional_mom.pdf");

            const attendanceFilled = {
                by_gender: {
                    Male: meetingAttendees.by_gender.Male || 0,
                    Female: meetingAttendees.by_gender.Female || 0,
                    Others_gender_wise: meetingAttendees.by_gender.Others || 0,
                    total:
                        (meetingAttendees.by_gender.Male || 0) +
                        (meetingAttendees.by_gender.Female || 0) +
                        (meetingAttendees.by_gender.Others || 0),
                },
                by_social_category: {
                    SC: meetingAttendees.by_social_category.SC || 0,
                    ST: meetingAttendees.by_social_category.ST || 0,
                    OBC: meetingAttendees.by_social_category.OBC || 0,
                    General: meetingAttendees.by_social_category.General || 0,
                    Others_caste_wise: meetingAttendees.by_social_category.Others || 0,
                    total: (meetingAttendees.by_social_category.SC || 0) +
                        (meetingAttendees.by_social_category.ST || 0) +
                        (meetingAttendees.by_social_category.OBC || 0) +
                        (meetingAttendees.by_social_category.General || 0) +
                        (meetingAttendees.by_social_category.Others || 0),
                },
            };

            const formData = new FormData();
            formData.append("meeting_id", String(meetingDetailsNirnany?.pn_meeting_id ?? ""));
            formData.append("meeting_language", selectedLang ?? "");
            formData.append("meeting_summary", result.translated_transcript_en ?? "");
            formData.append("english_minutes", summaryHtml ?? "");
            formData.append("regional_minutes", htmlSummaryReg ?? "");
            formData.append("language_id", String(selectedLangId ?? ""));
            formData.append("state_lgd_code", String(state_code ?? ""));
            formData.append("local_body_code", String(local_body_code ?? ""));
            formData.append("local_body_type_code", String(entity_level ?? ""));
            formData.append("ip_address", ip ?? "");
            formData.append("user_id", String(user_id ?? ""));
            formData.append("user_name", user_name ?? "");


            formData.append("attendance_filled", JSON.stringify(attendanceFilled));

            formData.append("en_pdf", enPdfBlob, "english_mom.pdf");
            if (selectedLang !== "English") {
                formData.append("reg_pdf", regPdfBlob, "regional_mom.pdf");
            }

            await axios.post(
                "https://meetingonline.gov.in/gsn_api/live/ss/v2/register_mom",
                formData,
                {
                    headers: {
                        accept: "application/json",
                        lang: "en-IN",
                        timestamp: "01012025000000",
                        accesskey: "A1B2C3D4-E5F6-7890-ABCD-112233445566",
                        secretkey: "f8a92e3b65cd11ee98fc7b6d1234aa77",
                    },
                }
            );

            setIsSuccess(true);
            handleSubmitMinutes();
            setShowResultModal(true);

        } catch (error) {
            console.error("API Error:", error);
            setIsSuccess(false);
            setShowResultModal(true);
        } finally {
            setLoading(false);
        }
    };


    const handleSubmitMinutes = async () => {
        const confirmSubmit = window.confirm(
            "Are you sure you want to final submit the Minutes of Meeting?\n\nOnce submitted, it cannot be edited later on."
        );

        if (!confirmSubmit) {
            toast.info("Final submission cancelled.");
            return;
        }

        try {
            const payload = {
                task_id: task_id,
            };

            const res = await protectedAPI.post(
                `${baseUrl}api/submit-minutes`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = res.data;

            if (data?.msg_code === 200) {
                dispatch(setIsDirty(true));
                toast.success("Minutes saved successfully.");
            } else {
                toast.error(data?.msg || "Something went wrong while submitting.");
            }
        } catch (error) {
            console.error("Error submitting minutes:", error);
            toast.error("Failed to submit. Please try again.");
        }
    };
    const handleSaveDraft = async () => {
        const confirmSave = window.confirm(
            "The Minutes of Meeting (MoM) will be saved as a draft. You can review, edit, and final submit them later.\n\nDo you want to continue?"
        );

        if (!confirmSave) {
            toast.info("Draft save cancelled.");
            return;
        }

        try {
            const payload = {
                task_id: task_id,
            };

            const res = await protectedAPI.post(
                `${baseUrl}api/save-draft`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = res.data;

            if (data?.msg_code === 200) {
                toast.success("Draft saved successfully.");
            } else {
                toast.error(data?.msg || "Something went wrong while saving the draft.");
            }
        } catch (error) {
            console.error("Error saving draft:", error);
            toast.error("Failed to save draft. Please try again.");
        }
    };

    return (
        <Wrapper>
            <div className="card">
                <div className="card-body">
                    <div className="">
                        <div className="content-output-container mt-3"
                            onClick={() => handleSectionToggle('originTranscipt')}
                            style={{ cursor: 'pointer' }}>
                            <div className="content-output-text">
                                <div className="first-final-icon">
                                    <FaListAlt />
                                </div>
                                <p className="first-final-text">View {selectedLang} Transcript</p>
                            </div>
                            <div className="icons-actions">
                                <div className="icon-with-label" onClick={(e) => {
                                    e.stopPropagation();
                                    handleCopy(result?.original_transcript || '');
                                }}>
                                    <FaRegCopy />
                                    <span className="icon-label">Copy</span>
                                </div>
                                <FaCaretDown style={{
                                    cursor: 'pointer',
                                    transform: toggle.originTranscipt ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.3s ease',
                                }} />
                            </div>
                        </div>
                        {toggle.originTranscipt && (
                            <div className="result-content">
                                <p>
                                    {result?.original_transcript || 'No Audio Content Available for Transcription.'}
                                </p>
                            </div>
                        )}
                    </div>

                    <div className="bhashini-skip-translation">
                        <div
                            className="content-output-container for-summary mt-3"
                            onClick={() => handleSectionToggle('summaryEn')}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="content-output-text">
                                <div className="first-final-icon">
                                    <FaListAlt />
                                </div>
                                <p className="first-final-text">
                                    View Minutes of the Meeting (English)
                                </p>
                            </div>

                            <div className="icons-actions">
                                <div
                                    className="translate-wrapper"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <div className="icon-with-label translate-icon-group">
                                        <FaDownload />
                                        <span className="icon-label">Export</span>
                                        <FaCaretDown className="down-arrow" />
                                    </div>
                                    <div className="translate-dropdown">
                                        <ul>
                                            <li onClick={() => handleExportPDF()}>Export as PDF</li>
                                        </ul>
                                    </div>
                                </div>

                                <div
                                    className="translate-wrapper"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <div className="icon-with-label translate-icon-group">
                                        <FaGlobe />
                                        <span className="icon-label">Translate</span>
                                        <FaCaretDown className="down-arrow" />
                                    </div>
                                    <div className="translate-dropdown">
                                        <ul>
                                            {regionalLanguages.map((lang) => (
                                                <li
                                                    key={lang.code}
                                                    value={lang.code}
                                                    onClick={() => handleLanguageTranslate(lang.code)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    {lang.label}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div
                                    className={`icon-with-label`}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setIsEditing(true);
                                    }}
                                >
                                    <FaPencilAlt />
                                    <span className="icon-label">Edit</span>
                                </div>
                                <div
                                    className="icon-with-label"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleCopyRendered(summaryHtml);
                                    }}
                                >
                                    <FaRegCopy />
                                    <span className="icon-label">Copy</span>
                                </div>




                                <FaCaretDown
                                    style={{
                                        cursor: 'pointer',
                                        transform: toggle.summaryEn ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.3s ease'
                                    }}
                                />
                            </div>
                        </div>

                        {toggle.summaryEn && (
                            <>
                                {!isEditing ? (
                                    <div className="result-content" ref={summaryRef}>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    summaryHtml ||
                                                    `<div class="text-muted">No Summary Content is Available.</div>`,
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <div className="dds">
                                        <CKEditor
                                            editor={ClassicEditor as any}
                                            data={summaryHtml || "<p>Start typing...</p>"}
                                            onChange={(event, editor) => {
                                                setSummaryHtml(editor.getData());
                                            }}
                                        />
                                        <div className="my-3 d-flex justify-content-end">
                                            <button
                                                type="button"
                                                className="btn btn-success"
                                                onClick={handleSubmit}
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </div>

                    {isLoadingTranslation && (
                        <p className="mt-3 text-center loading-text">Translating... Please wait.</p>
                    )}

                    {regionalContent && !isLoadingTranslation && (
                        <TranslateSummary
                            content={regionalContent}
                            language={regionalLangCode}
                            htmlSummaryReg={htmlSummaryReg}
                            setHtmlSummaryReg={setHtmlSummaryReg}

                        />
                    )}
                </div>
                {
                    portal !== "N" ? (
                        <div style={{ padding: "0px 30px" }}>
                            <div className="d-flex justify-content-end mb-2">
                                <button className="btn btn-warning" onClick={handleNewFile}>
                                    <FaFileAlt className="me-2" />
                                    Start New Upload
                                </button>
                            </div>

                            {/* Save Draft & Submit Center */}
                            <div className="d-flex justify-content-center gap-3 mb-3">
                                <button
                                    className="btn btn-secondary"
                                    onClick={handleSaveDraft}
                                >
                                    Save as Draft
                                </button>

                                <button
                                    className="btn btn-success gap-3"
                                    onClick={handleSubmitMinutes}
                                >

                                    Final Submit
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div
                            className="d-flex justify-content-center mb-2"
                            style={{ padding: "0px 30px" }}
                        >
                            <button
                                className="btn btn-success shiny-btn d-flex align-items-center gap-2"
                                onClick={() => setShowConfirm(true)}
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                        Submitting...
                                    </>
                                ) : (
                                    "Submit"
                                )}
                            </button>
                        </div>
                    )
                }
            </div>

            <div className="card bg-danger-cus mt-2">
                <div className="card-body">
                    <h5 className="card-heading text-center text-danger">DISCLAIMER</h5>
                    <p>
                        The AI-generated summaries are based on uploaded audio/video and may contain errors due to input quality or language variation. Please verify the content before official use. The Ministry of Panchayati Raj is not liable for any discrepancies.
                    </p>
                </div>
            </div>

            {showConfirm && (
                <>
                    <div
                        className="backdrop show"
                        onClick={() => setShowConfirm(false)}
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: "rgba(0,0,0,0.4)",
                            zIndex: 1040
                        }}
                    />

                    <div
                        className="modal fade show"
                        style={{
                            display: "block",
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 1050,
                            width: "400px"
                        }}
                    >
                        <div className="modal-content p-3">
                            <h5 className="text-center mb-3">Are you sure you want to submit this final version?</h5>

                            <div className="d-flex justify-content-between mt-3">
                                <button
                                    className="btn btn-secondary w-50 me-2"
                                    onClick={() => setShowConfirm(false)}
                                >
                                    Wait
                                </button>

                                <button
                                    className="btn btn-primary w-50"
                                    onClick={handleConfirmSubmit}
                                >
                                    Yes
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {showResultModal && (
                <div className="custom-modal-backdrop">
                    <div className="custom-modal">
                        {isSuccess ? (
                            <>
                                <FaCheckCircle size={52} className="success-icon" />
                                <h3>Data Saved Successfully</h3>
                                <p>
                                    The meeting details have been saved successfully.
                                    You may now safely close this browser tab.
                                </p>
                            </>
                        ) : (
                            <>
                                <FaExclamationTriangle size={52} className="error-icon" />
                                <h3>Unable to Save Data</h3>
                                <p>
                                    Something went wrong while saving the data.
                                    Please close this tab and try again after some time.
                                </p>
                            </>
                        )}
                    </div>
                </div>
            )}
        </Wrapper>
    );
};

export default FinalResult;
